import { NameIdType, ProjectMember } from "../../enums/project";

export enum ValidationFormsModeEnum {
  ADD = "add",
  EDIT = "edit",
  VIEW = "view",
}

export type ValidationFormErrors = Record<string, string>;

export interface ProjectFormValues {
  name: string;
  client: string | null;
  responsibleContact: string;
  budget: string;
  deadline: string;
  company: string | null;
  description: string;
  priority: string;
  stage: string;
  members: ProjectMember[];
}

export interface SellingFormValues {
  name: string;
  client: string | null;
  responsibleContact: string;
  budget: string;
  deadline: string;
  company: string | null;
  description: string;
  stage: string;
}

export interface CompanyFormValues {
  name: string;
  site: string | null;
  description: string | null;
  responsibleContact: string;
  type: string;
}

export interface ClientFormValues {
  firstName: string;
  lastName: string;
  responsibleContact: string;
  type: string;
  email: string;
  phone: string;
  company: string;
}

export interface TaskFormValues {
  name: string;
  priority: string;
  deadline: string | null;
  project: NameIdType | null;
  selling: NameIdType | null;
  description: string | null;
  members: ProjectMember[];
}

export interface FinanceFormValues {
  name: string;
  type: string;
  budget: string;
  project: NameIdType | null;
  selling: NameIdType | null;
  description: string | null;
}

export interface AddMemberTeamFormValues {
  firstName: string;
  lastName: string;
  email: string;
}